import HNSColors from "../../../../../ui library/HNSColors";

import ActionButton from "./ActionButton";

export default function OutlinedButton({ disabled, label, onClick }) {
  return (
    <ActionButton
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      sx={{
        border: !disabled ? "1px solid" : "",
        backgroundColor: !disabled ? (HNSColors.neutrals[900]) : HNSColors.neutrals[800],
        color: !disabled ? HNSColors.secondary[500] : HNSColors.neutrals[500],
        borderColor: !disabled ? HNSColors.secondary[500] : "",
        "&:hover": {
          backgroundColor: HNSColors.secondary[900],
          color: HNSColors.secondary[500],
          border: 'none',
        },
      }}
    >
      {label}
    </ActionButton>
  );
}
